import { ChangeEvent } from 'react';
import { Flex, HStack, Switch, Text } from '@chakra-ui/react';
import { usePageTextContent } from 'context/pageTextContent';

interface Props {
  isIncluded: boolean;
  onChange(value: boolean): void;
}

export const IncludedNetworkSection = (props: Props) => {
  const { isIncluded, onChange } = props;

  const { content } = usePageTextContent<SearchPageContent>();

  const { showNetworks, showNetworksDescription } = content;

  const onNetworkIncludedChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <HStack
      w="full"
      justify="space-between"
      bg="gray.100"
      py="1.75rem"
      px="2.5rem"
    >
      <Flex direction="column">
        <Text>{showNetworks}</Text>

        <Text fontSize="0.875rem">{showNetworksDescription}</Text>
      </Flex>

      <Switch
        size="md"
        onChange={onNetworkIncludedChange}
        isChecked={isIncluded}
      />
    </HStack>
  );
};
